import { render, staticRenderFns } from "./ListGhazal.vue?vue&type=template&id=2cad6f8a&"
import script from "./ListGhazal.vue?vue&type=script&lang=js&"
export * from "./ListGhazal.vue?vue&type=script&lang=js&"
import style0 from "./ListGhazal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports